export default function (response) {
    let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
    let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
    const blob = new Blob([response.data]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = String(filename + '.' + extension).trim().replaceAll('"', '');
    link.click();
}
